module.exports = __webpack_public_path__ + "media/honey-icons/icon-motion-sensor-43ed0942.svg";